import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.some";
import sortBy from 'lodash/sortBy';
import React from 'react';
import DefaultValue from './DefaultValue';
import PropTypeValue from './PropTypeValue';
import TypescriptTypeValue from './TypescriptTypeValue';
import { docletsToMap, getTypeName } from './utils';
export * from './types';

var isElementType = function isElementType(name, types) {
  return types.some(function (t) {
    if (typeof t === 'string') return t === name;
    return !!(name === null || name === void 0 ? void 0 : name.match(t));
  });
};

export default function renderProps(propsData) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      tokenMap = _ref.tokenMap,
      _ref$elementTypes = _ref.elementTypes,
      elementTypes = _ref$elementTypes === void 0 ? ['elementType', /React\.ComponentType(<.*>)?/] : _ref$elementTypes;

  return sortBy(propsData, 'name').filter(function (prop) {
    return !prop.tags.find(function (d) {
      return d.name === 'private' || d.name === 'ignore';
    });
  }).map(function (propData) {
    var _description$markdown;

    var name = propData.name,
        type = propData.type,
        defaultValue = propData.defaultValue,
        description = propData.description,
        tags = propData.tags,
        tsType = propData.tsType;
    var docletMap = docletsToMap(tags);
    var typeName = getTypeName(propData);
    var descHtml = (description === null || description === void 0 ? void 0 : (_description$markdown = description.markdownRemark) === null || _description$markdown === void 0 ? void 0 : _description$markdown.html) || '';
    var renderedType = null;
    if (tsType) renderedType = /*#__PURE__*/React.createElement(TypescriptTypeValue, {
      type: tsType,
      tags: tags,
      tokens: tokenMap
    });else if (type) renderedType = /*#__PURE__*/React.createElement(PropTypeValue, {
      type: type,
      tags: tags,
      tokens: tokenMap
    });
    return {
      name: name,
      tags: tags,
      typeName: typeName,
      description: descHtml,
      deprecated: docletMap.get('deprecated'),
      type: renderedType,
      defaultValue: defaultValue && /*#__PURE__*/React.createElement(DefaultValue, Object.assign({}, defaultValue, {
        isElementType: isElementType(typeName, elementTypes)
      })),
      propData: propData
    };
  });
}